module.exports = __webpack_public_path__ + "static/img/qcd.ff23718.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qcd.png
// module id = 7NCI
// module chunks = 1